// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomCheckmark_container__3EZfa","active":"CustomCheckmark_active__2gurR","disabled":"CustomCheckmark_disabled__2eWv0"};